

import _ from "lodash"
import { makeSearcher } from "../utils/Searcher"
import {searchProject as search} from '@/api/search' 
import {SEARCH_COMMITS,SEARCH_DISPATCHS} from "@/store/contracts" 
const state={    
    results: [],
    activeSearchKey:null
}
function findByKey(arr, key){
    for (let i = 0; i < arr.length; i++) {
        const result = arr[i]
        if(result.key===key){
            return result
        }
    }
}
const mutations={
    [SEARCH_COMMITS.NEW_SEARCH]: async function(state, {filter}){
        let keys = state.results.map(r=>parseInt(r.key))

        let key = 1
        if(keys.length){
            key = _.max(keys)
            key++
        }
        key = key.toString()

        const result = {
            key,
            filter,
            loaded: false,
            loading: false,
            error: null,
            result: null,
            pageSize:null,
            currentPage:null,
        }
        // makeSearcher(
        //     key,
        //     async (pageable)=>{
        //         return await search(filter,pageable).then(r=>r.data)    
        //     })
        
        state.results.push(result)
        state.activeSearchKey = key


    },
    [SEARCH_COMMITS.REMOVE_SEARCH](state, {key}){
        for (let i = 0; i < state.results.length; i++) {
            const result = state.results[i]
            if(result.key===key){
                state.results.splice(i,1)
                break
            }
        }
        if(state.activeSearchKey === key){
            state.activeSearchKey = null
        }
    },
    [SEARCH_COMMITS.ACTIVE_SEARCH](state, {key}){
        state.activeSearchKey = key
    },
    startLoad(state, {key,currentPage, pageSize}){
        
        const searcher = findByKey(state.results,key)
        searcher.loaded = false
        searcher.loading = true 
        searcher.error= null
        //searcher.result= null
        if(currentPage) searcher.currentPage = currentPage
        if(pageSize) searcher.pageSize = pageSize
    },
    endLoad(state, {key,result,error}){
        
        const searcher = findByKey(state.results,key)
        searcher.loading = false
        searcher.loaded = true        
        searcher.error= error
        searcher.result= result
        searcher.pageSize = null
        searcher.currentPage = null
    },  

}
const actions = {
        [SEARCH_DISPATCHS.LOAD_RESULT]: async function({state, commit}, {key, currentPage, pageSize}){
            if(!key){
                key = state.activeSearchKey
            }
            if(!key){
                throw('没有指定key!')
            }
        const searcher = findByKey(state.results,key)
        if(searcher){
            try{             
                const pageable = {
                    currentPage: currentPage||1,
                    pageSize: pageSize||20
                }
                
                if(searcher.currentPage===currentPage && searcher.pageSize===pageSize){
                    Promise.reject('相同的参数正在搜索中!')
                }
                commit('startLoad', {key, ...pageable})
                const result = await search(
                    searcher.filter,
                    pageable
                ).then(r=>r.data)
                
                commit('endLoad', {key, result})
            }catch(ex){
                commit('endLoad', {key, error: ex.message})
            }
        }
        
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
    
}